import Vue from 'vue'
import Vuex from 'vuex'

import themes from './modules/themes'
import chambers from './modules/chambers'
import sources from './modules/sources'
import articles from './modules/articles'
import feeds from '@/assets/feeds/feeds.json'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    corsProxy: 'https://ir-cors.herokuapp.com/'
  },
  mutations: {
    saveLocal(state,payload){
      let nameObj = payload.name;
      let nameTime = nameObj+"-time";
      //console.log("Save local: " + nameObj)
      try {
        localStorage.setItem(nameObj, JSON.stringify(payload.data))
        localStorage.setItem(nameTime, Date.now());
        localStorage.setItem('lastSave', Date.now());
      } catch(e) {
        console.log(e)
      }
    },
  },
  actions: {
    init({dispatch}) {
      let time = localStorage.getItem('lastSave');
      console.log("Last saved data: " + (new Date(parseInt(time))).toLocaleString())
      if(!time || Date.now()-time > 1000 * 60 * 60 * 24){ //If more than 24h
        console.log("Local data is too old. Clear all locally stored data");
        localStorage.clear();
      }

      feeds.themes.forEach((t) => {
        dispatch('themes/createAndAdd',{theme: t})
      })

    },
    loadLocal(context,payload){
      return new Promise((resolve, reject) => {
        let nameObj = payload.name;
        let nameTime = nameObj+"-time";
        //console.log("Try to load local: " + nameObj)
        let data = JSON.parse(localStorage.getItem(nameObj));
        let time = localStorage.getItem(nameTime);
        reject("Force reject")
        if(!data){
          reject("No local data: " + nameObj)
        }
        else if(payload.expire){
          if(!time){
            reject("No timestamp for: " + nameTime)
          }
          else if((Date.now()-time) > payload.expire * 1000 * 60){
            reject("Local data " + nameObj + " is expired: " + Math.floor((Date.now()-time) / 1000 / 60) + " minutes")
          }
        }
        resolve({name: payload.name, data: data, time: time})
      })

    },
  },
  modules: {
    themes,
    chambers,
    sources,
    articles
  }
})
